import { storage, StorageKeys } from '@/services/storage';

export const getStoredDashboardEditLockHolder = (): string | null =>
  storage.get(StorageKeys.DashboardEditLock)?.tabId ?? null;

export const setStoredDashboardEditLockHolder = (tabId: string): void => {
  storage.set(StorageKeys.DashboardEditLock, { tabId });
};

export const clearStoredDashboardEditLockHolder = (tabId?: string): void => {
  if (tabId && getStoredDashboardEditLockHolder() !== tabId) return;
  storage.remove(StorageKeys.DashboardEditLock);
};
